require('./openYoungTutorTypeSelect.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');

// @ helpers
const { formatText } = require('core/i18n').i18n;

// @ commons
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @ actions
const openYoungTutorTypeActions = require('actions/openYoungTutorType');

class OpenYoungTutorTypeSelect extends React.Component {

    render() {
        const { immOpenYoungTutorType, set } = this.props;
        const titularLabel = formatText('openYoungTutorTypeSelect-openYoungTutorTypeSelect_tutorType');
        const combosPlaceholder = formatText('openYoungTutorTypeSelect-openYoungTutorTypeSelect_combosPlaceholder');
        const errorState = immOpenYoungTutorType.get('isDirty') && !immOpenYoungTutorType.get('isValid');
        const errorMessage = formatText('openYoungTutorTypeSelect-openYoungTutorTypeSelect_errorMessage');
        const titularOptions = [
            {
                value: 'Padre',
                label: formatText('openYoungTutorTypeSelect-openYoungTutorTypeSelect_father')
            }, {
                value: 'Madre',
                label: formatText('openYoungTutorTypeSelect-openYoungTutorTypeSelect_mother')
            }, {
                value: 'Tutor Legal',
                label: formatText('openYoungTutorTypeSelect-openYoungTutorTypeSelect_guardian')
            }
        ];

        return (
            <article className="open-young-tutor-type-select">
                <div className="row">
                    <div className="col-xs-7 open-young-tutor-type-select__input-grid-section">
                        <OKSelect
                            errorMessage={errorMessage}
                            errorState={errorState}
                            label={titularLabel}
                            onChange={(optionObject) => set(optionObject.value)}
                            options={titularOptions}
                            placeholder={combosPlaceholder}
                            searchable={false}
                            tooltipContent="openYoungTutorTypeSelect-openYoungTutorTypeSelect_tooltip"
                            value={immOpenYoungTutorType.get('value')}
                        />
                    </div>
                </div>
            </article>
        );
    }
}

OpenYoungTutorTypeSelect.propTypes = {
    immOpenYoungTutorType: PropTypes.object.isRequired,
    set: PropTypes.func.isRequired,
};

module.exports.constructor = OpenYoungTutorTypeSelect;

module.exports.OpenYoungTutorTypeSelect = connect(null,
    {
        set: openYoungTutorTypeActions.set,
    }
)(OpenYoungTutorTypeSelect);